type Props = {
  children: React.ReactNode;
  className?: string;
};

export default function SectionEyebrow({ children, className = '' }: Props) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className="w-8 h-px bg-clay-500" aria-hidden />
      <span className="eyebrow text-clay-600">{children}</span>
    </div>
  );
}
